"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAILURE_MODAL_VIEW = exports.SUCCESS_MODAL_VIEW = exports.FORM_MODAL_VIEW = exports.MESSAGE_BUTTON_VIEW = void 0;
exports.MESSAGE_BUTTON_VIEW = 'message-button-view';
exports.FORM_MODAL_VIEW = 'form-modal-view';
exports.SUCCESS_MODAL_VIEW = 'success-modal-view';
exports.FAILURE_MODAL_VIEW = 'failure-modal-view';
